import React from 'react';
import Slides from './jumbetron/Slides';

export default function home() {
  return (
    <div id="home">
      <Slides />
    </div>
  );
}
